import React, { Component } from 'react';
import { Stack, Box, Toolbar, Drawer, Button } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import MobileNavToggleButton from '../Navigation/ToggleButton/MobileNavToggleButton';
import DevButton from '../../DevButton';
import UserProfileButton from '../../UserProfileButton';
import Branding from '../Navigation/Branding';
import Navigation from '../Navigation';
import TogglePreviewButton from '../../common/TogglePreviewButton';

class PortalAppBar extends Component {
  render() {
    return (
      <MuiAppBar
        className={
          'myOdu__topNav ' +
          (this.props.isSideBarOpen ? 'sideBarVisible open ' : 'sidebarVisible closed ')
        }
        position="fixed"
        open={this.props.isSidebarOpen}
        elevation={0}
      >
        <div className="myOdu__decorativeLine navbarArea" style={{ width: '100%' }}>
          {' '}
          &nbsp;{' '}
        </div>
        <Toolbar>
          <Branding isPositionTopNav={true} isCrownVisible={false} isTitleVisible={true} />
          <Box sx={{ flexGrow: 1 }} />

          {/* //NOTE: this button hides with css on <= small screen */}
          {this.props.isAdmin && <DevButton />}

          {/* <TogglePreviewButton /> */}

          {/* //NOTE: this button hides with css on <= small screen */}
          <UserProfileButton />

          <MobileNavToggleButton
            isMenuOpen={this.props.isSidebarOpen}
            onToggle={this.props.onToggle}
          />
        </Toolbar>

        {this.props.isMobile && (
          <Drawer
            id="mobileNav__drawer"
            variant="temporary"
            className={
              'myOdu__mobileNavDrawer d-block d-sm-none ' +
              (this.props.isImpersonating ? ' impersonating' : '')
            }
            anchor={'top'}
            open={this.props.isSidebarOpen}
            onClose={this.props.onToggle}
          >
            <MobileNavToggleButton
              isMenuOpen={this.props.isSidebarOpen}
              onToggle={this.props.onToggle}
            />
            <Navigation
              isMobile={true}
              data={{ isOpen: this.props.isSidebarOpen }}
              onToggle={this.props.onToggle}
            />
          </Drawer>
        )}
      </MuiAppBar>
    );
  }
}

export default PortalAppBar;
